import React from "react";
import { Row, Col, Typography, Card, Space } from "antd";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const { Title, Paragraph } = Typography;

const PricingPage = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Helmet>
        <title>{t('pricing.title')}</title>
      </Helmet>

      {/* Hero Section */}
      <section style={{ padding: "80px 20px", textAlign: "center", background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <Title level={1} style={{ color: "white", fontSize: "clamp(2rem, 5vw, 3.5rem)", marginBottom: "24px" }}>
            {t('pricing.noFees')}
          </Title>
          <Paragraph style={{ fontSize: "clamp(1rem, 2.5vw, 1.25rem)", color: "rgba(255,255,255,0.9)" }}>
            {t('pricing.freeService')}
          </Paragraph>
        </div>
      </section>

      {/* Free Service Section */}
      <section style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={12}>
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Title level={2} style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
                  {t('pricing.whyFree')}
                </Title>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('pricing.whyFreeDesc1')}
                </Paragraph>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('pricing.whyFreeDesc2')}
                </Paragraph>
              </Space>
            </Col>
            <Col xs={24} lg={12}>
              <div style={{ textAlign: "center", fontSize: "clamp(60px, 12vw, 150px)", lineHeight: "1", padding: "20px 0" }}>🆓</div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: "80px 20px", background: "#f8f9fa" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Title level={2} style={{ textAlign: "center", marginBottom: "60px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('pricing.whatYouGet')}
          </Title>
          <Row gutter={[32, 32]}>
            <Col xs={24} md={12} lg={6}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", height: "100%" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>🔒</div>
                <Title level={4}>{t('pricing.secureEscrow')}</Title>
                <Paragraph>
                  {t('pricing.secureEscrowDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", height: "100%" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>💬</div>
                <Title level={4}>{t('pricing.realtimeChat')}</Title>
                <Paragraph>
                  {t('pricing.realtimeChatDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", height: "100%" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>🤖</div>
                <Title level={4}>{t('pricing.aiAssistant')}</Title>
                <Paragraph>
                  {t('pricing.aiAssistantDesc')}
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <Card style={{ textAlign: "center", border: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", height: "100%" }}>
                <div style={{ fontSize: "48px", marginBottom: "20px" }}>📎</div>
                <Title level={4}>{t('pricing.fileSharing')}</Title>
                <Paragraph>
                  {t('pricing.fileSharingDesc')}
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* Future Plans */}
      <section style={{ padding: "80px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={12}>
              <div style={{ textAlign: "center", fontSize: "clamp(60px, 12vw, 150px)", lineHeight: "1", padding: "20px 0" }}>🚀</div>
            </Col>
            <Col xs={24} lg={12}>
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Title level={2} style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
                  {t('pricing.futurePlans')}
                </Title>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('pricing.futurePlansDesc1')}
                </Paragraph>
                <Paragraph style={{ fontSize: "18px", lineHeight: "1.6" }}>
                  {t('pricing.futurePlansDesc2')}
                </Paragraph>
              </Space>
            </Col>
          </Row>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: "80px 20px", background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white", textAlign: "center" }}>
        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <Title level={2} style={{ color: "white", marginBottom: "24px", fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}>
            {t('pricing.startToday')}
          </Title>
          <Paragraph style={{ fontSize: "18px", color: "rgba(255,255,255,0.9)", marginBottom: "40px" }}>
            {t('pricing.allFeaturesDesc')}
          </Paragraph>
        </div>
      </section>
    </>
  );
};

export default PricingPage;